export const sparkedParkingDataSelector = ({sparkedParkingData}) => sparkedParkingData